import {RelativeTime, Timeline} from '@primer/react'
import type {TimelineItem} from '../../../page-data/payloads/timeline'
import {Author} from '../../Author'
import {PullRequestReviewText} from './items/PullRequestReviewText'
import {PullRequestReviewAction} from './items/PullRequestReviewAction'
import {IssueEventText} from './items/IssueEventText'
import {PullRequestCommitText} from './items/PullRequestCommitText'
import {OtherItemText} from './items/OtherItemText'

// using a switch for better type narrowing
function ItemText({item}: {item: TimelineItem}) {
  switch (item.type) {
    case 'PullRequestReview':
      return <PullRequestReviewText item={item} />
    case 'PullRequestCommit':
      return <PullRequestCommitText item={item} />
    case 'IssueEvent':
      return <IssueEventText item={item} />
    default:
      return <OtherItemText item={item} />
  }
}

function ItemAction({item}: {item: TimelineItem}) {
  switch (item.type) {
    case 'PullRequestReview':
      return <PullRequestReviewAction item={item} />
    default:
      return null
  }
}

export function TimelineItemAction({item}: {item: TimelineItem}) {
  return (
    <Timeline.Body className="d-flex flex-row flex-justify-between flex-items-start">
      <span>
        <Author login={item.user?.displayLogin} /> <ItemText item={item} />{' '}
        <RelativeTime className="color-fg-muted" datetime={item.timestamp} />
      </span>
      <ItemAction item={item} />
    </Timeline.Body>
  )
}
